import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";

import { TermSheetPracticePanel } from "@/components/TermSheetPracticePanel";
import { Button } from '@/components/admin/ui';
import {
  parsePracticeGameType,
  type PracticeGameType,
} from "@/lib/term-sheet-practice";

type PracticeSearch = {
  resource_key: string;
  title: string;
  kind: "static" | "cloud";
  sheet_id?: number;
  game_type?: PracticeGameType;
};

function TermSheetPracticePage() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  if (!search.resource_key?.trim()) {
    return (
      <div className="space-y-4">
        <p className="text-sm text-red-600">Missing resource_key.</p>
        <Button
          variant="secondary"
          onClick={() => void navigate({ to: "/admin/term-sheets" })}
        >
          ← Term sheets
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Link
        to="/admin/term-sheets"
        className="text-sm text-nova-primary hover:underline"
      >
        ← Term sheets
      </Link>
      <TermSheetPracticePanel
        resourceKey={search.resource_key}
        title={search.title || search.resource_key}
        kind={search.kind ?? "static"}
        sheetId={search.sheet_id}
        gameType={search.game_type ?? null}
        onGameTypeChange={(next) => {
          void navigate({
            to: "/admin/term-sheets/practice",
            search: {
              resource_key: search.resource_key,
              title: search.title,
              kind: search.kind,
              sheet_id: search.sheet_id,
              game_type: next ?? undefined,
            },
          });
        }}
      />
    </div>
  );
}

export const Route = createFileRoute("/admin/term-sheets/practice")({
  component: TermSheetPracticePage,
  validateSearch: (raw: Record<string, unknown>): PracticeSearch => ({
    resource_key: typeof raw.resource_key === "string" ? raw.resource_key : "",
    title: typeof raw.title === "string" ? raw.title : "",
    kind: raw.kind === "cloud" ? "cloud" : "static",
    sheet_id:
      typeof raw.sheet_id === "number"
        ? raw.sheet_id
        : typeof raw.sheet_id === "string" && raw.sheet_id.trim()
          ? Number(raw.sheet_id)
          : undefined,
    game_type: parsePracticeGameType(raw.game_type),
  }),
});
